import type { ToggleButtonDesignTokens, ToggleButtonTokenSections } from '@primeuix/themes/types/togglebutton';

export const root: ToggleButtonTokenSections.Root = {
    padding: '0rem',
    borderRadius: '{content.borderRadius}',
    gap: '0.5rem',
    fontWeight: '500',
    disabledBackground: '{formField.disabledBackground}',
    disabledBorderColor: '{formField.borderColor}',
    disabledColor: '{formField.disabledColor}',
    invalidBorderColor: '{formField.invalidBorderColor}',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    },
    transitionDuration: '{formField.transitionDuration}',
    sm: {
        fontSize: '{formField.sm.fontSize}',
        padding: '0.25rem'
    },
    lg: {
        fontSize: '{formField.lg.fontSize}',
        padding: '0.25rem'
    }
};

export const icon: ToggleButtonTokenSections.Icon = {
    disabledColor: '{formField.disabledColor}'
};

export const content: ToggleButtonTokenSections.Content = {
    padding: '0.25rem 0.75rem',
    borderRadius: '{content.borderRadius}',
    checkedShadow: '{extend.shadowsm}',
    sm: {
        padding: '0.25rem 0.75rem'
    },
    lg: {
        padding: '0.25rem 0.75rem'
    }
};

export const colorScheme: ToggleButtonTokenSections.ColorScheme = {
    // Segmented control (O8): the track is transparent inside the select-button
    // border; the selected segment is the theme selection (blue-lighter + wine,
    // 9.9:1) lifted with shadow-small. No orange: orange is the CTA surface only.
    light: {
        root: {
            background: 'transparent',
            checkedBackground: 'transparent',
            hoverBackground: 'transparent',
            borderColor: 'transparent',
            color: '{text.color}',
            hoverColor: '{text.hoverColor}',
            checkedColor: '{highlight.focusColor}',
            checkedBorderColor: 'transparent'
        },
        content: {
            checkedBackground: '{highlight.focusBackground}'
        },
        icon: {
            color: '{text.mutedColor}',
            hoverColor: '{text.hoverColor}',
            checkedColor: '{highlight.focusColor}'
        }
    },
    dark: {
        root: {
            background: '{surface.950}',
            checkedBackground: '{surface.950}',
            hoverBackground: '{surface.950}',
            borderColor: '{surface.950}',
            color: '{surface.400}',
            hoverColor: '{surface.300}',
            checkedColor: '{surface.0}',
            checkedBorderColor: '{surface.950}'
        },
        content: {
            checkedBackground: '{primary.hoverColor}'
        },
        icon: {
            color: '{surface.400}',
            hoverColor: '{surface.300}',
            checkedColor: '{surface.0}'
        }
    }
};

export default {
    root,
    icon,
    content,
    colorScheme
} satisfies ToggleButtonDesignTokens;